import React from 'react'
import ThemeForm from './ThemeForm'

const Edit = () => {
  return (
    <ThemeForm title={'Edit'}/>
  )
}

export default Edit
